<app-offcanvas-base
  [returnUrl]="returnUrl"
  [returnParams]="returnParams">
  <ng-container title>
    <div class="offcanvas-title">{{ isExisting ? 'Edit' : 'Add' }} banking details</div>
  </ng-container>
  <ng-container body>
    @if (form) {
      <form
        [formGroup]="form"
        [boFormOptions]="options"
        (ngSubmit)="onSubmit()"
        novalidate>
        @if (status === bankingStatus.New || status === bankingStatus.Reviewed) {
          <div class="alert alert-warning small">
            <i class="iconoir-info-circle"></i>
            Banking details verification is pending
          </div>
        }
        <bo-non-field-errors />
        <div class="row">
          <div class="col">
            <app-form-field
              boFieldPath="bank"
              label="Bank"
              placeholder="Bank name"
              [autocomplete]="'off'"></app-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <app-form-field
              boFieldPath="branch_code"
              label="Branch code"
              placeholder="Branch code"
              [autocomplete]="'off'"></app-form-field>
          </div>
          <div class="col-6">
            <app-form-field
              boFieldPath="account_type"
              label="Account type"
              placeholder="Account type"
              [autocomplete]="'off'"></app-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col-6">
            <app-form-field
              boFieldPath="account_number"
              label="Account number"
              placeholder="Account number"
              [autocomplete]="'off'"></app-form-field>
          </div>
          <div class="col-6">
            <app-form-field
              boFieldPath="account_holder"
              label="Account holder"
              placeholder="Account holder"
              [autocomplete]="'off'"></app-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-label">Upload proof of banking details</div>
            @if (!documentUrl) {
              <app-upload
                #uploadRef
                [settings]="uploadSettings"
                textExtra="Please ensure your file is in PDF format."
                (uploadSuccess)="documentUploaded($event)">
              </app-upload>
            } @else {
              <app-file-upload
                [documentUrl]="documentUrl"
                [documentDownloadUrl]="documentDownloadUrl"
                [file]="file"
                (changeFile)="onChangeDocument($event)">
              </app-file-upload>
            }
            <hr />
            @if (status !== bankingStatus.Approved) {
              <div class="alert alert-light small">
                <i class="iconoir-info-circle"></i> Directors approval required for this action to be marked as
                complete.
              </div>
            }
          </div>
        </div>
        <div class="row gy-3 offcanvas-buttons">
          <div class="col-12 col-sm-auto">
            <app-offcanvas-cancel-btn [returnUrl]="returnUrl"></app-offcanvas-cancel-btn>
          </div>
          <div class="col-12 col-sm-auto ms-sm-auto">
            <app-submit
              [disabled]="!isValid()"
              [busy]="busy"
              btnID="saveBankDetailsBtn"
              [icon]="false"
              label="Save"></app-submit>
          </div>
        </div>
      </form>
    } @else {
      <app-loader></app-loader>
    }
  </ng-container>
</app-offcanvas-base>
